import React, { useContext } from "react"
import { navigate } from "gatsby"
import { AuthContext } from "../context/auth"
import Skeleton from "./Skeleton"

const PrivateRoute = ({ children, location }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext)
  if (isLoading) {
    return <Skeleton />
  }

  if (!isAuthenticated && location.pathname !== `/login`) {
    navigate("/login")
    return null
  }

  return <div>{children}</div>
}

export default PrivateRoute
